import { gql } from 'apollo-angular';
import { dashboardViewerCanFragment } from '../dashboard/dashboard.fragments';
import { workspaceUserItemFragment } from '../user/user.fragments';

export const dashboardRoleFragment = gql`
  fragment DashboardRoleFragment on DashboardRole {
    id
    title
    accessLevel

    user {
      ...WorkspaceUserItem
    }

    dashboard {
      id
      dashboardRoles {
        edges {
          node {
            id
            accessLevel
          }
        }
      }
      ...DashboardViewerCanFragment
    }
  }
  ${dashboardViewerCanFragment}
  ${workspaceUserItemFragment}
`;
